const MONTH_KEY_LENGTH = 7;

const OBSERVER_EXTRA_TOP_OFFSET_PX = 10;

export { MONTH_KEY_LENGTH, OBSERVER_EXTRA_TOP_OFFSET_PX };
